<template>
  <div>
    <div class="border border-orange-100 rounded-md p-4 bg-orange-50">
      <div class="flex items-start justify-between" :class="{'grayscale opacity-70': !applicable}">
        <div class="flex items-center gap-2">
          <img
            src="@/public/v1/icons/Percentage-Orange.png"
            alt="Percentage Icon"
            title="Percentage Icon"
            class="w-6 h-6 text-orange-500"
          />
          <!-- <UIcon name="i-ph-seal-percent" class="text-orange-500 h-6 w-6" /> -->
          <div>
            <p class="font-bold text-blue-900">
              Save {{ discount.join("") }} with {{ couponCode }}
            </p>
            <p class="text-gray-600 text-sm">
              Min order {{ mov.join("") }}
              <span v-if="props.data.scope && props.data.scope.toLowerCase() !== 'delivery'">|  Min item ₹{{ miv }}</span>
            </p>
          </div>
        </div>
        <button :disabled="!applicable" class="text-red-600 font-semibold" @click="applyCoupons">
          Apply
        </button>
      </div>
      <div v-if="!applicable && remaining_amount != null" class="my-1 px-10 flex items-center">
                <UProgress
                  :value="remaining_percentage"
                  class="h-2 rounded opacity-100"
                  :max="100"
                />
                <p class="text-sm text-primary px-2">₹{{ remaining_amount }}/{{ mov.join("") }}</p>
      </div>
      <div v-if="usage_limit" class="my-1 px-8">
        <p class="text-xs md:text-sm text-red-600">{{ usage_message }}</p>
      </div>
      <div v-if="tncs.length || (notApplicableMessage && scope.toLowerCase() !== 'delivery')" class="mt-2 text-sm text-gray-700">
      <div
        class="flex items-center cursor-pointer font-semibold text-primary-500"
        @click="tncExpanded = !tncExpanded"
      >
        <p>
          <span class="text-lg">{{ tncExpanded ? '▲' : '▼' }}</span> Show details
        </p>
      </div>
    <div v-show="tncExpanded" class="mt-2">
      <ul v-if="tncs.length" class="list-disc list-inside text-gray-500 pl-5">
        <p class="font-semibold pb-2">Terms and Conditions</p>
        <div v-for="(tnc, index) in tncs" :key="index">
          <li v-if="index < tncToShow" class="pb-1">
            <span>
              {{
                tncToShow == 100
                  ? tnc
                  : exceeds200(tnc) && !moreTncIndex.includes(index)
                  ? `${tnc.slice(0, 150)}`
                  : tnc
              }}
              <span
                v-if="
                exceeds200(tnc) && 
                tncToShow != 100 && 
                !moreTncIndex.includes(index)
                "
                @click="moreOrLess('more', index)"
                class="text-blue-500 cursor-pointer"
              ><span class="text-gray-500">. . .</span> more</span
              >
              <span
                v-if="
                exceeds200(tnc) && 
                tncToShow != 100 && 
                moreTncIndex.includes(index)
                "
                @click="moreOrLess('less', index)"
                class="text-blue-500 cursor-pointer pl-4"
              >less</span
              >
            </span>
          </li>
        </div>
      </ul>
      <div v-if="notApplicableMessage && scope.toLowerCase() !== 'delivery'" class="mt-3 text-gray-500">
        <p class="font-semibold pb-2">How do I avail this coupon?</p>
        <span class="text-sm text-gray-500 whitespace-pre-line">{{ notApplicableMessage }}</span>
      </div>
      <p
        v-if="tncs.length > 3 && !props.data.readMore"
        @click="readMore()"
        class="mt-1 cursor-pointer font-medium"
      >
        Read more <span class="">▼</span>
      </p>
      <p
        v-if="props.data.readMore"
        @click="hide()"
        class="mt-1 cursor-pointer font-medium"
      >
        Read less <span class="">▲</span>
      </p>
    </div>
      </div>
    </div>
    <hr class="mt-4" />
  </div>
</template>

<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const dayjs = useDayjs();
const props = defineProps(["data"]);
const emits = defineEmits(["apply", "refresh"]);
const auth = useAuth();
const { gtag } = useGtag();
const isAuthenticated = auth && auth.access_token;
const tncExpanded = ref(false);
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : {
      user_name: null,
      user_phone: null,
      user_email: null,
    };
const couponCode = props.data.coupon_code;
const remaining_amount = props.data.remaining_amount
const usage_limit = props.data.usage_limit
const usage_message = usage_limit ? props.data.usage_message : null  
const remaining_percentage = computed(()=> (remaining_amount/props.data.minimum_order_value)* 100);
const scope = props.data.scope
const miv = props.data.minimum_item_value
const applicable = props.data.applicable;
const notApplicableMessage = props.data.message;
const tncs = props.data?.tnc ? props.data?.tnc : [];
const tncToShow = ref(props.data.tncToShow);
const moreTncIndex = ref([]);
const discount = [];
const cart = useCart();
const data = computed(() => cart.response?.data);
const error = computed(() => cart.response?.error);
const summary = computed(() =>
  error.value ? [] : data.value?.map((k) => k.summary).flat() || []
);
const deliveryCharge = computed(()=> summary.value.filter((k) => k.type.toLowerCase() === "delivery"))
const totalDeliveryCharge = deliveryCharge.value.reduce((sum, item) => sum + Number(item.total), 0)
if (props.data.offer_type.toLowerCase() === "value") {
  if(props.data.scope === 'delivery'){
    discount.push('₹',Math.min(props.data.offer_value, totalDeliveryCharge));
  }else{
    discount.push("₹", props.data.offer_value);
  }
}
if (props.data.offer_type.toLowerCase() === "percentage") {
  discount.push(props.data.offer_value, "%");
}
const mov = ["₹", props.data.minimum_order_value];
const validity = dayjs(
  `${props.data.valid_upto} 23:59`,
  "DD/MM/YYYY HH:mm"
).format("MMM DD, YYYY hh:mm A");

const couponTextArray = [
  "Get",
  discount.join(""),
  "off",
  "on your purchase! Applicable on a mininum item value of",
  mov.join(""),
];
if (props.data.max_limit && Number(props.data.max_limit > 0)) {
  const maxLimit = ["₹", props.data.max_limit];
  couponTextArray.splice(3, 0, "upto", maxLimit.join(""));
}

const applyCoupons = () => {
  if(!applicable) return;
  emits("apply", couponCode);
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: "Available offers Apply cta",
    [EventParameter.COUPON_CODE]: couponCode?.toUpperCase(),
  });
};

function readMore() {
  tncToShow.value = 100;
  props.data.readMore = true;
  moreTncIndex.value = [];
  // emits("refresh", couponCode);
}
function hide() {
  tncToShow.value = 3;
  props.data.readMore = false;
  // emits("refresh", couponCode);
}
const exceeds200 = (text) => {
  if (text.trim().split("").length > 200) {
    return true;
  }
  return false;
};
const moreOrLess = (type, index) => {
  if (type === "more") {
    if (!moreTncIndex.value.includes(index)) {
      moreTncIndex.value.push(index);
    }
  } else {
    const i = moreTncIndex.value.indexOf(index);
    if (i !== -1) {
      moreTncIndex.value.splice(i, 1);
    }
  }
};
</script>
